import React from 'react';

import meta from '~/commons/config/meta';

import CompetitionSmry from '../blocks/CompetitionSmry.jsx';
import UserProfileSmry from '../blocks/UserProfileSmry.jsx';
import Announcements from '../blocks/Announcements.jsx';

const PageDashboard = () => {
  meta.set();

  return (
    <div className="container-fluid p-0">
      <div className="row no-gutters">
        <div className="col-12 col-lg-9">
          <CompetitionSmry />
        </div>
        <div className={`
          col-12 col-lg bg-window bg-lighter
          d-flex align-items-center
        `}>
          <UserProfileSmry />
        </div>
      </div>
      <div>
        <Announcements />
      </div>
    </div>
  );
};

export default PageDashboard;
